// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode  } from 'swiper/modules';

function basicSlider(){
	const slider = new Swiper('.basic-slider', {
		modules: [Navigation, Pagination, Autoplay, FreeMode],
		loop: true,
		draggable: true,
		freeMode: {
			enabled: true,
		},
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1,

		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
		navigation:{
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		breakpoints: {
			760: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 1,
				spaceBetween: 20
			},
		},
	});
}

export { basicSlider };